import classnames from 'classnames';
import { inject, observer } from 'mobx-react';
import React from 'react';

import SingleButton, { getClassName, getDisabledClassName } from '@/components/SingleButton';
import { BUTTON_TYPE, TRACKING_MSG_TYPE, TRACKING_TYPE } from '@/utils/constants';
import { addDialogue } from '@/utils/sessionUtils';
import {
  handleArticleBtnClick,
  handleLiveBtnClick,
  handleOptionBtnClick,
  handlePopupArticleBtnClick,
  handleRedirectionBtnClick,
  trackingHandler,
  handleClickMoreOrder,
} from '@/utils/btnClickHandler';
import { getContent, handleClickHistoryButton, handleIfActivateShopeepay, handleRedirectBack } from '@/utils/tools';
import Msg from '@/components/Msg';
import { confirm as btnModalConfirm } from './BtnArticleModal';
import reporter from '@/utils/report';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { USING_IS_STYLE_MAP } from '@/types/General';
import handleClickIntent from '@/utils/intent/handleClickIntent';
import sendBotMessageToAgent from '@/utils/sendBotMessageToAgent';
import { getLiveAgentRecommenderInfo } from '@/utils/agent';

import './style.scss';

const PREFIX = 'general-container';

@tracker
@inject(getChildInject('initStore', 'agentStore', 'modalStore', 'sessionStore'))
@observer
export default class General extends React.PureComponent {
  static defaultProps = {
    // props
    dialogueId: '',
    dialogueType: '',
    isDisabled: false,
    msgContent: '',
    options: [],
    // stores
    initStore: {},
    agentStore: {},
    modalStore: {},
    sessionStore: {},
  };

  constructor(props) {
    super(props);
  }

  generateOption = (option, index) => {
    // 旧逻辑中 isBtnDisabled 表示隐藏按钮
    // 历史消息中 添加 disabledBtn 表示显示但是禁用按钮
    const {
      button_type,
      isBtnDisabled,
      isDisabledStyle,
      onClick,
      button_id,
      disabledBtn,
      query_callback = {},
      trackingname: buttonTrackingname,
      trackingdata: buttonTrackingdata,
    } = option;
    const {
      dialogueId, dialogueType, chatEntry, listPos, initStore, agentStore, taskbotName,
      modalStore, context, nodePointId, isHistory, historyDialogueId, historySessionId,
      customCallback = {},
    } = this.props;
    const button_text = getContent(option);

    let trackingname = TRACKING_TYPE.STANDARDIZE_BUTTON;
    const trackingdata = {
      node_point_id: nodePointId,
      button_text: getContent(option),
      button_id,
      button_type,
      chat_session_id: isHistory ? historySessionId : (initStore.sessionId || ''),
      chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
      if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
    };
    let handleClick = onClick || (() => { });

    if (!button_type) {
      console.warn('Invalid Params button_type');
      return null;
    }

    switch (button_type) {
      case 'btn_live':
        const { loadingInAgent, inAgent } = agentStore;
        if ((loadingInAgent || inAgent || isBtnDisabled) && !isHistory) {
          return null;
        }
        const { userType, enquiryType, triggerLiveAgentRecommender } = getLiveAgentRecommenderInfo({
          presetUserType: option.user_type_id,
          presetEnquiryType: option.enquiry_type_id,
        });

        trackingname = TRACKING_TYPE.AGENT;
        handleClick = () => {
          handleLiveBtnClick(
            {
              dialogueId,
              dialogueType: chatEntry || dialogueType,
              text: button_text,
              listPos,
              queue_name: option.queue_name,
              user_type: userType,
              enquiry_type: enquiryType,
              isHistory,
              triggerLiveAgentRecommender,
            },
            {
              trackingname,
              trackingdata,
            },
          );
        };
        break;
      case 'btn_redirection':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {

          if (!isHistory) {
            addDialogue({
              dialogueId,
              dialogueType,
              from: 'user',
              type: 'Msg',
              data: { content: button_text },
            });

            // 暂时不加
            // 只有不调用后端接口的重定向，才走前端上传。。。。
            // if (!option?.callback && option?.uri_key !== 'request_order_return_page') {
            //   uploadMessageToSave({
            //     dialogueId,
            //     messages: [{
            //       message_text: button_text,
            //       is_sent_by_user: true
            //     }]
            //   });
            // }
          }

          handleRedirectionBtnClick(
            {
              ...option,
              isHistory,
            },
            {
              trackingname,
              trackingdata,
            },
            () => {
              handleRedirectBack(option, {
                dialogueId,
                listPos,
              });
            },
          );
        };
        break;
      case 'btn_taskbot':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {
          handleOptionBtnClick(
            {
              ...option,
              isHistory,
            },
            {
              dialogueId,
              dialogueType,
              context,
            },
            {
              trackingname,
              trackingdata,
            },
            customCallback,
          );
        };
        break;
      case 'btn_cancel_order':
        if (isBtnDisabled && !isHistory) {
          return null;
        }
        // 提供的cancel reasons为空，则不展示cancel按钮
        if (!(option?.order_extra?.cancel_reasons.length) && !isHistory) {
          return null;
        }

        handleClick = () => {
          trackingHandler({
            trackingname,
            trackingdata,
          });

          if (isHistory) {
            handleClickHistoryButton();
            return;
          }

          modalStore.SHOW_ORDERCANCELREASON_MODAL();
          modalStore.UPDATE_MODAL_ORDERCANCELREASON({
            ...option.order_extra,
            dialogueId,
            dialogueType,
            node_id: option.node_id,
            text_key: option.text_key,
            text_value: option.text_value,
            listPos,
            customCallback,
          });
        };
        break;
      case 'btn_activate_shopeepay':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {
          if (!isHistory) {
            addDialogue({
              dialogueId,
              dialogueType,
              from: 'user',
              type: 'Msg',
              data: { content: button_text },
            });
          }

          handleRedirectionBtnClick(
            {
              ...option,
              isHistory,
            },
            {
              trackingname,
              trackingdata,
            },
            () => {
              handleIfActivateShopeepay({
                sessionId: initStore.sessionId,
                content: getContent(option),
                dialogueId,
              });
            },
          );
        };
        break;
      case 'btn_article':
        // 这期先不上这个按钮
        return null;
      case 'btn_feedback':
        isDisabledStyle && option.style++;
        break;
      case 'btn_modal':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {
          const { btn_modal_callback } = option;
          const { id } = this.props;
          const trackingArticleDetailBasicData = {
            chat_session_id: trackingdata.chat_session_id,
            chat_dialogue_id: trackingdata.chat_dialogue_id,
            bot_id: Number(btn_modal_callback.article.kb_bot_id),
            intent_id: Number(btn_modal_callback.article.kb_intent_id),
            article_id: btn_modal_callback.article.id || btn_modal_callback.article.article_number,
            article_title: btn_modal_callback.article.title,
          };

          trackingHandler({
            trackingname,
            trackingdata,
          });

          if (isHistory) {
            handleClickHistoryButton();
            return;
          }

          btnModalConfirm({
            ...btn_modal_callback,
            id,
            index,
            trackingArticleDetailBasicData,
            customCallback,
          });
        };
        break;
      case 'btn_pop_article':
        handleClick = () => {
          handlePopupArticleBtnClick(
            option,
            {
              dialogueId,
              dialogueType,
              context,
            },
            {
              trackingname,
              trackingdata,
            },
            (res) => {
              if (res) {
                const trackingArticleDetailBasicData = {
                  chat_session_id: trackingdata.chat_session_id,
                  chat_dialogue_id: trackingdata.chat_dialogue_id,
                  bot_id: Number(res.kb_bot_id),
                  intent_id: Number(res.kb_intent_id),
                  article_id: res.id || res.article_number,
                  article_title: res.title,
                };

                modalStore.UPDATE_MODAL_ARTICLE({
                  ...res,
                  trackingArticleDetailBasicData,
                  isHistory,
                });
                modalStore.SHOW_ARTICLE_MODAL();
              }
            },
          );
        };
        break;
      case 'btn_more_order':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {
          handleClickMoreOrder({ nodePointId, dialogueId, dialogueType, taskbotName, isHistory }, option, { trackingname, trackingdata });
        };
        break;
      case 'btn_kb_intent':
        if (isBtnDisabled && !isHistory) {
          return null;
        }

        handleClick = () => {
          const { loadingInAgent, inAgent } = agentStore;

          trackingHandler({
            trackingname: buttonTrackingname || trackingname,
            trackingdata: buttonTrackingdata || trackingdata,
          });

          if (isHistory) {
            return;
          }

          if (loadingInAgent || inAgent) {
            sendBotMessageToAgent({ content: getContent(option) });
          } else {
            handleClickIntent(getContent(option), {...query_callback, ...customCallback});
          }
        };

        break;
      default:
        reporter.apiLog(`Unused button type: ${button_type}`, { level: 'warn' });
    }

    if (!button_text) {
      console.warn(`Button Type: ${button_type} could not get a text content.`);
    }

    const props = {
      key: `button-${index}`,
      passedRef: (ele) => (this.props.passedRef(ele, index)),
      text: button_text,
      handleClick,
      className: disabledBtn ? getDisabledClassName(option.style) : getClassName(option.style),
      disabled: disabledBtn,
      trackingindex: `${listPos}-${index}`,
      trackingname: buttonTrackingname || trackingname,
      trackingdata: buttonTrackingdata ? JSON.stringify(buttonTrackingdata) : trackingname === TRACKING_TYPE.AGENT
        ? JSON.stringify({ ...trackingdata })
        : JSON.stringify({
          node_point_id: nodePointId,
          chat_session_id: isHistory ? historySessionId : initStore.sessionId || '',
          chat_dialogue_id: isHistory ? historyDialogueId : dialogueId,
          button_details: [{
            button_text,
            button_id,
            button_type,
          }],
          if_history: isHistory ? TRACKING_MSG_TYPE.HISTORY : TRACKING_MSG_TYPE.REAL_TIME,
        }),
    };

    return <SingleButton {...props} />;
  };

  render() {
    const { msgContent, options, usingIsStyle } = this.props;

    return (
      <div className={PREFIX}>
        <Msg className={USING_IS_STYLE_MAP[usingIsStyle]} content={msgContent} />
        <div className="options">
          {options.map((option, index) => {
            return this.generateOption(option, index);
          })}
        </div>
      </div>
    );
  }
}
